    <div class="modal-body" [formGroup]="form">
      <div class="row justify-content-center mb-3">
          <div class="col-11 p-0">
            <mdb-form-control class="form-fill">
              <input
                mdbInput
                formControlName="email"
                [mdbAutocomplete]="autocompleteEmail"
                maxlength="128"
                type="text"
                (keydown.enter)="passOption($event)"
                class="form-control form-control--paybee"
              />
              <label mdbLabel class="form-label form-label--paybee">Donor Email</label>
              @if (form.controls.email.invalid && form.controls.email.touched && !isSameDonor) {
                <span class="form-fill-error">Invalid Donor Email</span>
              }
              @else if (isSameDonor) {
                <span class="form-fill-error">Please select different user to move cart to.</span>
              }
            </mdb-form-control>
            <mdb-autocomplete #autocompleteEmail="mdbAutocomplete">
              @for(option of searchResult; track option.data.id) {
                <mdb-option [value]="option.searchString" (click)="passOption(option.searchString)">
                    {{ option.searchString }}
                </mdb-option>
              }
            </mdb-autocomplete>
          </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-11 p-0">
          <mdb-form-control class="form-fill">
            <input
              mdbInput
              formControlName="name"
              [mdbAutocomplete]="autocompleteName"
              maxlength="128"
              type="text"
              (keydown.enter)="passOption($event)"
              class="form-control form-control--paybee"
            />
            <label mdbLabel class="form-label form-label--paybee">Donor Name</label>
            @if (form.controls.name.invalid && form.controls.name.touched && !isSameDonor) {
              <span class="form-fill-error">Invalid Donor Name</span>
            } 
            @else if (isSameDonor) {
              <span class="form-fill-error">Please select different user to move cart to.</span>
            }
          </mdb-form-control>
          <mdb-autocomplete #autocompleteName="mdbAutocomplete">
            @for(option of searchResult; track option.data.id) {
              <mdb-option [value]="option.searchString"
                (click)="passOption(option.searchString)">
                {{ option.searchString }}
              </mdb-option>
            }
          </mdb-autocomplete>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex paybee-modal-footer">
      <a class="btn btn-sm modal-outline-button modal-outline-button-new waves-effect waves-light mr-3" (click)="close()" >Cancel</a>
      <a class="btn btn-sm modal-success-button waves-effect waves-light" (click)="onConfirm()">Move</a>
    </div>  
  